import React from "react";
import styled from "styled-components";
import { Span } from "../../../../../Span";
import { Box } from "../../../../../Box";
import { SitePlanValues } from "../../../../../../types/SitePlanValues";
import {
  getFileExtension,
  getFileNameWithoutExtension,
} from "../../../../../FileUpload/_/FileUtil/FileUtil";
import { Flex } from "../../../../../Flex";

interface Props {
  id: string;
  uploads: SitePlanValues[];
}

const UploadUnitWrapper = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.neutrals.ln10};
  border: 1px solid;
  border-color: ${({ theme }) => theme.colors.neutrals.ln30};
`;

const FileTypeWrapper = styled(Span)`
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.neutrals.mn80};
  text-transform: uppercase;
`;

export const ReviewFormUploadPhotos: React.FC<Props> = ({ id, uploads }) => {
  return (
    <Box id={id}>
      {uploads.length === 0 && (
        <Span mb={3}>
          <UploadUnitWrapper mb={3} borderRadius="radio" padding={[2, 2, 2, 3]}>
            <Span>N/A</Span>
          </UploadUnitWrapper>
        </Span>
      )}

      {uploads.length !== 0 && (
        <Span mb={3}>
          {uploads.map((upload, index) => {
            return (
              <UploadUnitWrapper
                key={index}
                mb={3}
                borderRadius="radio"
                padding={[2, 2, 2, 3]}
              >
                <Span
                  data-testid={`${id}-filename-${index}`}
                  fontSize={2}
                  lineHeight={2}
                >
                  {getFileNameWithoutExtension(upload.fileName)}
                </Span>
                <FileTypeWrapper
                  data-testid={`${id}-filetype-${index}`}
                  ml={3}
                  padding={1}
                  borderRadius="fileType"
                  fontSize={1}
                  lineHeight={0}
                >
                  {getFileExtension(upload.fileName)}
                </FileTypeWrapper>
              </UploadUnitWrapper>
            );
          })}
        </Span>
      )}
    </Box>
  );
};
